var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.847 23.8057L32.5956 38.2358L29.3725 23.879L14.5032 23.8057L18.4946 0H35.2326C41.1792 0 46 4.8208 46 10.7675V23.8057H39.847ZM8.57008 28.6401H24.8312L28.77 46H10.7675C4.8208 46 0 41.1792 0 35.2326V10.7675C0 4.8208 4.8208 0 10.7675 0H13.1989L8.57008 28.6401ZM43.0701 28.5669H46V35.2326C46 41.1792 41.1792 46 35.2326 46H34.2458L43.0701 28.5669Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.9a62f1d6ae6a5f25b6fe0864f11c5d1d.svg";
export { ForwardRef as ReactComponent };